import { render, staticRenderFns } from "./NotificationPreview.vue?vue&type=template&id=ef77ed28&scoped=true&"
import script from "./NotificationPreview.vue?vue&type=script&lang=js&"
export * from "./NotificationPreview.vue?vue&type=script&lang=js&"
import style0 from "./NotificationPreview.vue?vue&type=style&index=0&id=ef77ed28&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef77ed28",
  null
  
)

export default component.exports